import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "src/contexts/auth-provider";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { GET_EVENTS_BY_STORE_ID } from "src/constants/queries";
import { failureToast } from "src/utils/toasts";
import { RootState } from "src/store/index";
import { set_events } from "src/store/features/events-slice";
import type { MenuListActiveFilter } from "src/constants/menuListActiveFilter";

export const useEventsByStoreCorrelationId = () => {
  const [isEventsLoading, setIsEventsLoading] = useState(false);
  const dispatch = useDispatch();
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();

  const { events, listActiveFilter } = useSelector((state: RootState) => state.events);

  const fetchEventsByStoreCorrelationId = useCallback(
    async (activeFilterOverride?: MenuListActiveFilter) => {
      if (!hasRestaurant?.correlationId) {
        return;
      }

      setIsEventsLoading(true);

      try {
        const activeFilter = activeFilterOverride ?? listActiveFilter;
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: GET_EVENTS_BY_STORE_ID,
          variables: {
            storeCorrelationId: hasRestaurant?.correlationId,
            activeFilter,
          },
        });

        if (data?.data?.storeEvents) {
          dispatch(set_events(data.data.storeEvents));
        }
      } catch (err) {
        console.error("Error fetching events by store:", err);
        failureToast("Failed to fetch events by store");
      } finally {
        setIsEventsLoading(false);
      }
    },
    [axBe, hasRestaurant?.correlationId, dispatch, listActiveFilter]
  );

  return {
    events,
    isEventsLoading,
    fetchEventsByStoreCorrelationId,
  };
};
